module.exports = __webpack_public_path__ + "static/media/default-medal-image.f431a865.svg";